import { css } from "@emotion/css";
import { borderRadius, themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
export function BorderedContent({ children }: {
    children: React.ReactNode;
}) {
    return <div className={borderedContentStyles}>{children}</div>;
}
const borderedContentStyles = css({
    border: `1px solid ${themeTokens.color.border.primary}`,
    borderRadius: borderRadius.medium,
    overflow: "clip",
});
